import type { Bot } from '@/types/bot';

const FALLBACK_BOT_AVATARS: Record<string, string> = {
  '11111111-1111-1111-1111-111111111111': 'https://images.pexels.com/photos/100717/pexels-photo-100717.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
  '22222222-2222-2222-2222-222222222222': 'https://images.pexels.com/photos/15767559/pexels-photo-15767559.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
  '33333333-3333-3333-3333-333333333333': 'https://images.pexels.com/photos/771742/pexels-photo-771742.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
  '44444444-4444-4444-4444-444444444444': 'https://images.pexels.com/photos/1681010/pexels-photo-1681010.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
  '55555555-5555-5555-5555-555555555555': 'https://images.pexels.com/photos/26621094/pexels-photo-26621094.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
  '66666666-6666-6666-6666-666666666666': 'https://images.pexels.com/photos/7187265/pexels-photo-7187265.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
  '77777777-7777-7777-7777-777777777777': 'https://images.pexels.com/photos/1998170/pexels-photo-1998170.jpeg?auto=compress&cs=tinysrgb&w=400&h=400&fit=crop',
};

export function getBotAvatarSrc(bot: Pick<Bot, 'id' | 'name' | 'avatar_url'>): string | undefined {
  if (bot.avatar_url && !bot.avatar_url.startsWith('/avatars/bots/')) {
    return bot.avatar_url;
  }

  return FALLBACK_BOT_AVATARS[bot.id] || undefined;
}
